// Per rule: code-comments-required (ai.knowledge/global) — explains why, not what.
// Per rule: reference-rules-in-comments (ai.knowledge/global) — rules materially shaping this file are named.
// Per rule: ai-code-requires-tests (ai.knowledge/global) — covered by format-overage-price.test.ts.
//
// ENG-3727: billing.tsx previously used a falsy check (`planOverageRate ?`) which caused
// `0` (a valid paid-plan rate returned by the backend when the Stripe link is broken)
// to fall through to "Unknown". Extracting the logic here makes the explicit-null check
// testable in isolation without mounting the full Billing component tree.

/**
 * Formats a per-GB overage rate into a display-ready { currency, value } pair.
 *
 * Returns '$0.00' for zero — zero is a valid rate that should not render as "Unknown".
 * Returns 'Unknown' only for null/undefined, which indicate missing backend data.
 */
export function formatOveragePrice(rate: number | undefined | null): {
  currency: string;
  value: string;
} {
  // Explicit null/undefined check — per ENG-3727, `0` must not fall through here.
  if (rate === null || rate === undefined) {
    return { currency: '', value: 'Unknown' };
  }

  // Match existing rounding in billing.tsx (round to 2 decimal places via integer math).
  const rounded = Math.round(rate * 100) / 100;
  return { currency: '$', value: rounded.toFixed(2) };
}
